import React from 'react';
import PropTypes from 'prop-types';

const Wifi = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.836 18.412h.012m-3.29-3.279a4.637 4.637 0 0 1 6.557 0m-9.837-3.28a9.275 9.275 0 0 1 13.117 0"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 8.575c5.432-5.433 14.24-5.433 19.708 0"
    />
    <circle cx={11.738} cy={18.411} r={1.159} fill={color} />
  </svg>
);

Wifi.propTypes = {
  color: PropTypes.string
};

export default Wifi;
